<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:09:19
 * @LastEditTime: 2019-08-18 19:26:34
 * @LastEditors: Please set LastEditors
 -->
<template>
    <el-dialog
            title="信息"
            :visible="true"
            width="90%"
            :before-close="handleClose">
        <el-button type="primary" @click="exportData()">导出</el-button>
        <el-table
                ref="multipleTable"
                v-loading="loading"
                :data="tableData"
                border
                height="350"
                style="width: 100%;margin-top: 20px">
            <el-table-column
                    prop="production_batch"
                    label="生产批次号"
                    width="180"
            >
            </el-table-column>
            <el-table-column
                    prop="stock_in_time"
                    label="入库时间"
                    width="120"
            >
            </el-table-column>
            <el-table-column
                    prop="stock_out_sn"
                    label="出库单号"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="product_specs"
                    label="规格"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="to_sn"
                    label="收货客户代码"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="to_name"
                    label="收货客户名称"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="isgift"
                    label="是否赠品"
                    width="120"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                   <span v-if="scope.row.isgift == 1">赠品</span>
                   <span v-else>非赠品</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="production_date"
                    label="生产日期"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="expiring_date"
                    label="有效期至"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="warehouse_name"
                    label="出货仓库"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="stock_out_time"
                    label="出货时间"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="real_stock_out_num"
                    label="出货数量"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="logistics_code"
                    label="物流码"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="code_name"
                    label="标签类型"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination
                style="margin: 20px 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize">
        </el-pagination>
    </el-dialog>
</template>

<script>
    export default {
        name: "outstock-detail-dialog-goods",
        data() {
            return {
                loading:false,
                tableData:[],
                //分页
                pageNo: 1,//页码
                pageSize: 20,//每页现实的条数
                totalSize: 0,//总条数
            }
        },
        props:{
            product_sn:{
                type:String,
                default:''
            }
        },
        methods: {
            getData(){
                this.loading = true;
                this.$get('logistics','/statistics/out.products/datas', {
                    lang:'',
                    product_sn:this.product_sn,
                    per_page:this.pageSize,
                    page:this.pageNo
                }).then(res => {
                    this.loading = false;
                    this.tableData = res.data;
                    this.totalSize = res.meta.total;
                }).catch(function (error) {
                    this.loading = false;
                    console.log(error);
                });
            },
            //导出
            exportData(){
                let url = '',access_tokens = localStorage.getItem('access_tokens');
          

                window.open(this.$Base_Export
                    +'/statistics/out.products/datas.export?is_export=1&product_sn='+ this.product_sn+'&lang=' + ''+'&signature='+ this.$md5(access_tokens)

                )
            },
            /*分页*/
            handleSizeChange(val) {
                this.pageSize = val;
                this.pageNo = 1;
                this.getData();

            },
            handleCurrentChange(val) {
                this.pageNo = val;
                this.getData();


            },
            handleClose(){
                this.$emit('handleClose');
            }
        },
        created() {
            this.getData();

        },
    }
</script>

<style lang="scss" scoped>

</style>